<div class="message-text d-flex flex-row justify-content-center align-items-center">
  <div class="col-1">
    <mat-icon class="message-icon">info</mat-icon>
  </div>
  <div [ngClass]="{'col-10': data.showDismissIcon,'col-11': !data.showDismissIcon}">
    <div class="success-text ps-1" [innerHTML]="data.message | async"></div>
  </div>
  @if(data.showDismissIcon){
  <div class="col-md-1">
    <button mat-icon-button color="accent" (click)="dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  }